import { Link } from 'react-router-dom';
import homeImg3 from '../../assets/images/3.jpeg';

export default function About() {
    return (
        <section className="py-24 bg-surface">
            <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
                {/* Left column – single image */}
                <div className="order-2 lg:order-1">
                    <div className="rounded-2xl overflow-hidden shadow-2xl">
                        <img
                            alt="Kinetix facility"
                            className="w-full h-full object-cover"
                            src={homeImg3}
                        />
                    </div>
                </div>

                {/* Right column – text content */}
                <div className="order-1 lg:order-2">
                    <span className="text-primary font-bold uppercase tracking-widest text-sm mb-4 block">
                        Our Story
                    </span>
                    <h2 className="font-headline text-4xl font-extrabold text-on-surface mb-8 leading-tight">
                        Advanced Solutions for Better Care
                    </h2>
                    <p className="text-on-surface-variant text-lg leading-relaxed mb-8">
                        At Kinetix, we believe that the right therapy and rehabilitation equipment can transform lives.
                        From physiotherapy and occupational therapy to sensory integration and home care, our mission is
                        to deliver products that combine comfort, durability, and performance to support healthcare and
                        learning environments.
                    </p>
                    <div className="space-y-4 mb-10">
                        <div className="flex items-center gap-4">
                            <span className="material-symbols-outlined text-secondary">check_circle</span>
                            <span className="font-bold text-on-surface">Advanced Rehabilitation Products</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="material-symbols-outlined text-secondary">check_circle</span>
                            <span className="font-bold text-on-surface">Supporting Healthcare &amp; Education</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="material-symbols-outlined text-secondary">check_circle</span>
                            <span className="font-bold text-on-surface">Designed for Everyday Living</span>
                        </div>
                    </div>
                    <Link
                        to="/about"
                        className="inline-block px-8 py-4 bg-on-surface text-surface rounded-xl font-bold hover:bg-on-surface-variant transition-all"
                    >
                        Learn More About Us
                    </Link>
                </div>
            </div>
        </section>
    );
}